export default {
  message: '訊息',
  active: '上線',
  inactive: '當前不在線上',
  isTyping: '正在輸入',
  people: '名稱',
  groups: '群組',
  lastLogin: '上次登入',
  read: '已讀',
  am: '上午',
  pm: '下午',
  connecting: '連線中',
  cannotConnect: '無法連接至伺服器',
  retry: '重試',
  typeAMessage: '請輸入訊息',
  sending: '傳送中...'
}
